import request from '@/utils/request'
import {uuid} from 'vue-uuid'

export function getTimeZone(){
    return request({
      url: `/api/timezones`,
      method: "get"
    });
}

export function getIndustrialCodes(search){
    return request({
      url: `/api/industrialcodes?search=${search}`,
      method: "get"
    });
}

export function requestOTP(){
    return request({
      url: "/api/requestotp",
      method: "post",
      data: {idempotency: uuid.v1()}
    });
  }

export function moveProject(data){
    return request({
      url: "/api/moveproject",
      method: "post",
      data: data
    });
  }
